import { Paper } from '@mui/material';

import React from 'react';

/** The wrapper's side padding; the UW globals align their grid to it. */
export const COVERAGE_WRAPPER_SIDE_PADDING = '1.25rem';

const CoverageWrapper = ({
  children,
  extraPaddingRight,
  paddingTop = '2rem',
}: Readonly<{
  children: React.ReactNode;
  /** Space above the first section. */
  paddingTop?: string;
  /** Added to the right padding, e.g. to clear a rail that floats over it. */
  extraPaddingRight?: string;
}>) => {
  const paddingRight = extraPaddingRight
    ? `calc(${COVERAGE_WRAPPER_SIDE_PADDING} + ${extraPaddingRight})`
    : COVERAGE_WRAPPER_SIDE_PADDING;

  return (
    <Paper
      style={{
        overflowY: 'auto',
        padding: `${paddingTop} ${paddingRight} 0rem ${COVERAGE_WRAPPER_SIDE_PADDING}`,
        borderTopRightRadius: 'none',
        borderTopLeftRadius: 'none',
      }}
      className="contrast-text"
      elevation={4}
    >
      {children}
    </Paper>
  );
};

export default CoverageWrapper;
